import crudAction from '../actions'

export default {
  name: 'crmNotes',
  namespace: 'crm/notes',
  methods: [...crudAction]
}
